import React, { useEffect, useState } from "react";
import { Button } from "../../components/reusableComponents/Button";
import { Input } from "../../components/reusableComponents/Input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/Tabs";
import { Badge } from "../../components/reusableComponents/Badge";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/reusableComponents/Dialog";
import { Label } from "../../components/reusableComponents/Label";
import { DayPicker } from "react-day-picker";
import TaskModal from "../../components/reusableComponents/TaskModal";
import axios from "../../axios/AxiosInstance";
import { fr } from "date-fns/locale";
import { formatJsDate } from "../../utils/formatageDate";
import { motion, AnimatePresence } from "framer-motion";
import {
  Plus,
  Search,
  Calendar,
  Clock,
  User,
  CheckCircle2,
  AlertCircle,
  Circle,
  Filter,
  MoreHorizontal,
  Edit3,
  Trash2,
  Eye,
  CalendarDays,
  Users,
  Activity,
  TrendingUp,
} from "lucide-react";
import { toast } from "sonner";

const Task = () => {
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [takers, setTakers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("A faire");
  const [isUpdating, setIsUpdating] = useState(false);
  const [isTaskStatusOpen, setIsTaskStatusOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10),
  );

  const loadTasks = (date) => {
    axios
      .get(`/newtask/find-by-date?date=${date}`)
      .then((res) => {
        setTasks(res.data);
        const tasks = res.data;
        filtrerTaches("A faire", "", tasks);
        console.log(res.data);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    const date = new Date().toISOString();
    loadTasks(date);
    getAgencyUsers();
  }, []);

  // État du formulaire d'ajout/modification
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [currentTask, setCurrentTask] = useState({});

  // Compter les tâches par statut
  const taskCounts = {
    all: tasks.length,
    todo: tasks.filter(
      (task) => task.status !== "Effectuée" && task.status !== "annulée",
    ).length,
    done: tasks.filter((task) => task.status === "Effectuée").length,
    cancelled: tasks.filter((task) => task.status === "annulée").length,
  };

  // Fonction pour filtrer les tâches
  // Trie les tâches par priorité: haute > moyenne > basse
  const trierParPriorite = (tasks) => {
    const priorityOrder = { urgent: 0, high: 1, medium: 2, low: 3 };
    return [...tasks].sort((a, b) => {
      return priorityOrder[a.priority] - priorityOrder[b.priority];
    });
  };

  const getAgencyUsers = () => {
    axios("user/active").then((res) => {
      const usersArray = res.data.map((user) => {
        return {
          value: user._id,
          label: `${user.firstname} ${user.lastname}`,
          key: user._id,
        };
      });
      setTakers(usersArray);
    });
  };

  const updateOnCreate = (task) => {
    console.log(selectedDate);
    const dateObj = new Date(task.date);
    const formattedDate = dateObj.toISOString().slice(0, 10);
    console.log(formattedDate);
    if (selectedDate === formattedDate) {
      console.log("okokokokoo");
      const newTasks = [...tasks];
      newTasks.push(task);
      setTasks(newTasks);
      filtrerTaches(activeTab, searchTerm, newTasks);
    }
  };

  const filtrerTaches = (tab, search, newTasks = []) => {
    let resultats;
    if (newTasks.length === 0) resultats = tasks;
    else resultats = newTasks;

    if (tab === "A faire") {
      resultats = resultats.filter(
        (task) => task.status !== "Effectuée" && task.status !== "annulée",
      );
    }

    // Filtre par statut
    else if (tab !== "all") {
      resultats = resultats.filter((task) => task.status === tab);
      console.log(resultats);
    }

    // Filtre par terme de recherche
    if (search) {
      const searchLower = search.toLowerCase();
      resultats = resultats.filter((task) => {
        const commentMatch = task.comment?.toLowerCase().includes(searchLower);

        const clientMatch = task.clients?.some((client) =>
          client.companyName?.toLowerCase().includes(searchLower),
        );

        const candidateMatch = task.candidates?.some(
          (candidate) =>
            candidate.firstname?.toLowerCase().includes(searchLower) ||
            candidate.lastname?.toLowerCase().includes(searchLower),
        );

        return commentMatch || clientMatch || candidateMatch;
      });
    }

    // Filtre par date sélectionnée
    //resultats = resultats.filter(task => task.date === selectedDate);
    console.log(resultats);

    // Trie par priorité
    resultats = trierParPriorite(resultats);
    console.log(resultats);

    setFilteredTasks([...resultats]);
  };

  // Gestionnaire de changement de recherche
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    filtrerTaches(activeTab, value);
  };

  // Gestionnaire de changement d'onglet
  const handleTabChange = (value) => {
    setActiveTab(value);
    filtrerTaches(value, searchTerm);
  };

  // Gestionnaire de changement de date
  const handleDateChange = (e) => {
    const value = e.target.value;
    console.log(value);
    loadTasks(value);
    setSelectedDate(value);
    filtrerTaches(activeTab, searchTerm);
  };

  // Fonction pour ouvrir le formulaire de nouvelle tâche
  const handleAddTask = () => {
    setCurrentTask({
      title: "",
      description: "",
      priority: "medium",
      status: "todo",
      assignedTo: "",
      taskType: "",
      contactType: "client",
      dueDate: selectedDate,
      tags: [],
    });
    setIsViewMode(false);
    setIsTaskModalOpen(true);
  };

  // Fonction pour ouvrir le formulaire de modification
  const handleEditTask = (task) => {
    setCurrentTask({ ...task });
    setIsUpdating(true);
    setIsViewMode(false);
    setIsTaskModalOpen(true);
  };

  // Fonction pour voir les détails d'une tâche
  const handleViewTask = (task) => {
    setCurrentTask({ ...task });
    setIsViewMode(true);
    setIsTaskModalOpen(true);
  };

  // Fonction pour sauvegarder une tâche
  const handleSaveTask = () => {
    if (currentTask.id) {
      // Mise à jour d'une tâche existante
      const updatedTasks = tasks.map((task) =>
        task.id === currentTask.id ? { ...currentTask } : task,
      );
      setTasks(updatedTasks);
    } else {
      // Création d'une nouvelle tâche
      const newTask = {
        ...currentTask,
        id: `task${tasks.length + 1}`,
        createdAt: new Date().toISOString().slice(0, 10),
      };
      setTasks([...tasks, newTask]);
    }

    // Fermer le modal et rafraîchir les filtres
    setIsTaskModalOpen(false);
    filtrerTaches(activeTab, searchTerm);
  };

  // Fonction pour supprimer une tâche
  const handleDeleteTask = (id) => {
    const updatedTasks = tasks.filter((task) => task.id !== id);
    setTasks(updatedTasks);
    setFilteredTasks(
      updatedTasks.filter(
        (task) =>
          (activeTab === "all" || task.status === activeTab) &&
          task.dueDate === selectedDate,
      ),
    );
  };

  // Fonction pour changer le statut d'une tâche
  const handleStatusChange = (task, newStatus) => {
    const updatedTasks = tasks.map((t) =>
      t.id === task.id ? { ...t, status: newStatus } : t,
    );
    setTasks(updatedTasks);
    filtrerTaches(activeTab, searchTerm);
  };

  // Obtenez une couleur en fonction du statut
  const getStatusColor = (status) => {
    switch (status) {
      case "todo":
        return "bg-amber-100 text-amber-800 border-amber-200"; // Changer ici la couleur en rouge;
      case "in-progress":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Effectuée":
        return "bg-green-100 text-green-800 border-green-200";
      case "cancelled":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-red-100 text-red-800 border-red-200";
    }
  };

  // Obtenez le statut en français
  const getStatusLabel = (status) => {
    switch (status) {
      case "to do":
        return "À faire";
      case "done":
        return "Terminée";
      case "cancelled":
        return "Annulée";
      default:
        return status;
    }
  };

  // Obtenez une couleur en fonction de la priorité
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "Basse":
        return "bg-green-100 text-green-800";
      case "Moyenne":
        return "bg-blue-100 text-blue-800";
      case "Haute":
        return "bg-orange-100 text-orange-800";
      case "Urgente":
        return "bg-red-100 text-red-800";
      default:
        return "bg-red-100 text-red-800";
    }
  };

  // Obtenez le label de la priorité en français
  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "Basse":
        return "Basse";
      case "Moyenne":
        return "Moyenne";
      case "Haute":
        return "Haute";
      case "Urgente":
        return "Urgente";
      default:
        return priority;
    }
  };

  const onOpenChange = () => {
    setIsTaskModalOpen(false);
    setIsUpdating(false);
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="w-full p-8">
        {/* Header Section */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-slate-900 mb-2 flex items-center">
                <Activity className="w-8 h-8 mr-3 text-blue-600" />
                Gestion des Tâches
              </h1>
              <p className="text-lg text-slate-600">
                Organisez et suivez vos tâches quotidiennes efficacement
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-200">
                <Calendar className="w-4 h-4 text-slate-500" />
                <Input
                  type="date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  className="border-none bg-transparent text-sm font-medium text-slate-700 focus:ring-0"
                />
              </div>
              <motion.button
                onClick={handleAddTask}
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg shadow-sm transition-colors duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Plus className="w-4 h-4" />
                <span className="font-medium">Nouvelle Tâche</span>
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* Statistiques Rapides */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {[
            {
              label: "Total",
              value: tasks.length,
              icon: Activity,
              color: "bg-blue-100 text-blue-600",
              bgColor: "bg-blue-50"
            },
            {
              label: "À faire",
              value: tasks.filter(t => t.status === "todo").length,
              icon: Circle,
              color: "bg-amber-100 text-amber-600",
              bgColor: "bg-amber-50"
            },
            {
              label: "Terminées",
              value: tasks.filter(t => t.status === "done").length,
              icon: CheckCircle2,
              color: "bg-emerald-100 text-emerald-600",
              bgColor: "bg-emerald-50"
            },
            {
              label: "Annulées",
              value: tasks.filter(t => t.status === "cancelled").length,
              icon: AlertCircle,
              color: "bg-red-100 text-red-600",
              bgColor: "bg-red-50"
            },
          ].map((stat, index) => (
            <motion.div
              key={stat.label}
              className={`${stat.bgColor} rounded-xl p-6 border border-slate-200 hover:shadow-md transition-shadow duration-300`}
              whileHover={{ y: -2 }}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">{stat.label}</p>
                  <p className="text-2xl font-bold text-slate-900 mt-1">{stat.value}</p>
                </div>
                <div className={`p-3 rounded-lg ${stat.color}`}>
                  <stat.icon className="w-5 h-5" />
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Filtres et Recherche */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-6">
            <Tabs
              defaultValue="all"
              value={activeTab}
              onValueChange={handleTabChange}
              className="w-full lg:w-auto"
            >
              <TabsList className="grid w-full lg:w-auto grid-cols-4 bg-slate-100 p-1 rounded-lg">
                <TabsTrigger
                  value="A faire"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <Circle className="w-4 h-4 mr-2 text-amber-500" />
                  À faire
                  <Badge className="ml-2 bg-amber-100 text-amber-700 text-xs px-2 py-0.5">
                    {taskCounts.todo}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="Effectuée"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <CheckCircle2 className="w-4 h-4 mr-2 text-emerald-500" />
                  Terminées
                  <Badge className="ml-2 bg-emerald-100 text-emerald-700 text-xs px-2 py-0.5">
                    {taskCounts.done}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="annulée"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <AlertCircle className="w-4 h-4 mr-2 text-red-500" />
                  Annulées
                  <Badge className="ml-2 bg-red-100 text-red-700 text-xs px-2 py-0.5">
                    {taskCounts.cancelled}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="all"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <Activity className="w-4 h-4 mr-2 text-slate-500" />
                  Toutes
                  <Badge className="ml-2 bg-slate-100 text-slate-700 text-xs px-2 py-0.5">
                    {taskCounts.all}
                  </Badge>
                </TabsTrigger>
              </TabsList>
            </Tabs>

            <div className="flex items-center space-x-4 w-full lg:w-auto">
              <div className="relative flex-1 lg:w-80">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <Input
                  type="text"
                  placeholder="Rechercher une tâche..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="pl-10 bg-slate-50 border-slate-200 focus:bg-white transition-colors duration-200"
                />
              </div>
              <motion.button
                className="flex items-center space-x-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Filter className="w-4 h-4" />
                <span className="hidden sm:inline">Filtres</span>
              </motion.button>
            </div>
          </div>

          <Tabs
            defaultValue="all"
            value={activeTab}
            onValueChange={handleTabChange}
            className="w-full"
          >
            <TabsContent value="all" className="mt-6">
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: index * 0.05 }}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <Activity className="w-8 h-8 text-slate-400" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche trouvée
                        </h3>
                        <p className="text-slate-500 mb-6">
                          Vous n'avez aucune tâche pour cette date ou ce filtre.
                        </p>
                        <motion.button
                          onClick={handleAddTask}
                          className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors duration-200"
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          <Plus className="w-4 h-4" />
                          <span>Créer votre première tâche</span>
                        </motion.button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="A faire" className="mt-6">
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: index * 0.05 }}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <Circle className="w-8 h-8 text-amber-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche à faire
                        </h3>
                        <p className="text-slate-500 mb-6">
                          Vous n'avez aucune tâche à faire pour cette date.
                        </p>
                        <motion.button
                          onClick={handleAddTask}
                          className="inline-flex items-center space-x-2 bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-lg transition-colors duration-200"
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          <Plus className="w-4 h-4" />
                          <span>Créer une nouvelle tâche</span>
                        </motion.button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="Effectuée" className="mt-6">
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: index * 0.05 }}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <CheckCircle2 className="w-8 h-8 text-emerald-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche terminée
                        </h3>
                        <p className="text-slate-500">
                          Vous n'avez aucune tâche terminée pour cette date.
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="annulée" className="mt-6">
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: index * 0.05 }}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <AlertCircle className="w-8 h-8 text-red-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche annulée
                        </h3>
                        <p className="text-slate-500">
                          Vous n'avez aucune tâche annulée pour cette date.
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>
            </Tabs>
        </motion.div>
      </div>

      {isTaskModalOpen && (
        <TaskModal
          open={true}
          task={currentTask}
          takers={takers}
          isUpdating={isUpdating}
          onOpenChange={onOpenChange}
          updateOnCreate={updateOnCreate}
        />
      )}
    </div>

  );
};

export default Task;


const TaskCard = ({
  task,
  tasks,
  setTasks,
  filtrerTaches,
  activeTab,
  onEdit,
  onView,
  onDelete,
  onStatusChange,
  getStatusColor,
  getStatusLabel,
  getPriorityColor,
  getPriorityLabel,
}) => {
  const [isStatusMenuOpen, setIsStatusMenuOpen] = useState(false);
  const [isTaskStatusOpen, setIsTaskStatusOpen] = useState(false);
  const [statusCase, setStatusCase] = useState("");
  const [reportDate, setReportDate] = useState(null);
  const [cancelReason, setCancelReason] = useState(task.cancelReason);
  const [doneReason, setDoneReason] = useState(task.doneReason);
  const [currentDate, setCurrenDate] = useState(new Date());

  const close = () => {
    setIsTaskStatusOpen(false);
    setStatusCase("");
  };

  const doneTaskFunc = () => {
    axios
      .put(`newtask/${task._id}`, { status: "Effectuée", doneReason })
      .then((res) => {
        console.log(res);
        const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
        const newTasks = [...tasks];
        newTasks[taskIndex] = res.data;
        setTasks(newTasks);
        setReportDate(null);
        setCancelReason("");
        setIsTaskStatusOpen(false);
        setDoneReason("");
        filtrerTaches(activeTab, "", newTasks);
      })
      .catch((e) => console.log(e));
  };

  const cancelTaskFunc = () => {
    axios
      .put(`newtask/${task._id}`, { status: "annulée", cancelReason })
      .then((res) => {
        const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
        const newTasks = [...tasks];
        newTasks[taskIndex] = res.data;
        setTasks(newTasks);
        setReportDate(null);
        setIsTaskStatusOpen(false);
        setCancelReason("");
        setDoneReason("");
        filtrerTaches(activeTab, "", newTasks);
      });
  };

  const reportTaskDate = () => {
    axios.put(`newtask/${task._id}`, { date: reportDate }).then((res) => {
      const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
      let newTasks = [...tasks];
      newTasks[taskIndex] = res.data;
      newTasks = newTasks.filter(
        (task) => formatJsDate(task.date) === formatJsDate(currentDate),
      );
      setTasks(newTasks);
      setReportDate(null);
      setIsTaskStatusOpen(false);
      setCancelReason("");
      setDoneReason("");
      filtrerTaches(activeTab, "", newTasks);
    });
  };

  return (
    <motion.div
      className="bg-white border border-slate-200 rounded-xl shadow-sm p-6 hover:shadow-md transition-all duration-300"
      whileHover={{ y: -2 }}
      layout
    >
      <Dialog open={isTaskStatusOpen} onOpenChange={close}>
        <DialogContent className="bg-white rounded-2xl shadow-2xl p-6 max-w-md mx-auto">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold text-slate-800 text-center flex items-center justify-center">
              <Activity className="w-5 h-5 mr-2 text-blue-600" />
              Statut de la tâche
            </DialogTitle>
          </DialogHeader>

          {/* Boutons de statut */}
          <div className="mt-6 flex justify-center gap-3">
            {["Effectuée", "Reportée", "Annulée"].map((status) => {
              const colors = {
                Effectuée: "bg-emerald-600 hover:bg-emerald-700",
                Reportée: "bg-amber-500 hover:bg-amber-600",
                Annulée: "bg-red-600 hover:bg-red-700",
              };
              const isActive = statusCase === status;

              return (
                <motion.button
                  key={status}
                  onClick={() => setStatusCase(status)}
                  className={`px-6 py-3 rounded-lg text-white font-medium transition-all duration-200 ${colors[status]} ${
                    isActive
                      ? "ring-2 ring-offset-2 ring-blue-500 scale-105 shadow-lg"
                      : "opacity-90 hover:opacity-100"
                  }`}
                  whileHover={{ scale: isActive ? 1.05 : 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {status}
                </motion.button>
              );
            })}
          </div>

          {/* Formulaire selon statut sélectionné */}
          <AnimatePresence mode="wait">
            {statusCase && (
              <motion.div
                className="mt-6 space-y-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                {/* Effectuée */}
                {statusCase === "Effectuée" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-2 block">
                        Décrivez l'action menée
                      </Label>
                      <textarea
                        placeholder="Décris l'action menée..."
                        onChange={(e) => setDoneReason(e.target.value)}
                        value={doneReason}
                        className="w-full min-h-[100px] border border-slate-300 rounded-lg px-4 py-3 text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 resize-none transition-colors duration-200"
                      />
                    </div>
                    <motion.button
                      onClick={() => doneTaskFunc()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-emerald-600 hover:bg-emerald-700 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <CheckCircle2 className="w-4 h-4" />
                      <span>Marquer comme effectuée</span>
                    </motion.button>
                  </motion.div>
                )}

                {/* Reportée */}
                {statusCase === "Reportée" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-3 flex items-center">
                        <CalendarDays className="w-4 h-4 mr-2" />
                        Nouvelle date
                      </Label>
                      <div className="bg-slate-50 rounded-lg p-4">
                        <DayPicker
                          className="mx-auto"
                          showOutsideDays
                          mode="single"
                          locale={fr}
                          selected={reportDate}
                          onSelect={(date) => {
                            const newDate = new Date(date);
                            newDate.setHours(12);
                            setReportDate(newDate);
                          }}
                          classNames={{
                            day: "w-10 h-10 rounded-lg text-sm text-slate-700 hover:bg-amber-100 transition-colors duration-200",
                            selected: "bg-amber-500 text-white hover:bg-amber-600 transition-all duration-200",
                            today: "text-slate-900 font-semibold bg-slate-200",
                          }}
                        />
                      </div>
                    </div>
                    <motion.button
                      onClick={() => reportTaskDate()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-amber-500 hover:bg-amber-600 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <Clock className="w-4 h-4" />
                      <span>Reporter la tâche</span>
                    </motion.button>
                  </motion.div>
                )}

                {/* Annulée */}
                {statusCase === "Annulée" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-2 block">
                        Raison de l'annulation
                      </Label>
                      <textarea
                        placeholder="Indique la raison de l'annulation..."
                        onChange={(e) => setCancelReason(e.target.value)}
                        value={cancelReason}
                        className="w-full min-h-[100px] border border-slate-300 rounded-lg px-4 py-3 text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 resize-none transition-colors duration-200"
                      />
                    </div>
                    <motion.button
                      onClick={() => cancelTaskFunc()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-red-600 hover:bg-red-700 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <AlertCircle className="w-4 h-4" />
                      <span>Annuler la tâche</span>
                    </motion.button>
                  </motion.div>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </DialogContent>
      </Dialog>

      {/* Contenu Principal de la Carte */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <h3 className="text-lg font-semibold text-slate-900">{task.title}</h3>
            <Badge className={`${getPriorityColor(task.priority)} text-xs px-2 py-1`}>
              {getPriorityLabel(task.priority)}
            </Badge>
          </div>
          {(task.client?.name || (task.contactType === "interim" && task.candidate?.name)) && (
            <div className="flex items-center space-x-2 text-sm text-slate-600">
              <User className="w-4 h-4" />
              <span>
                {task.client?.name || (task.contactType === "interim" && task.candidate?.name) || ""}
              </span>
            </div>
          )}
        </div>

        <div className="flex items-center space-x-2">
          <Badge className={`${getStatusColor(task.status)} text-xs px-3 py-1`}>
            {getStatusLabel(task.status)}
          </Badge>
          <motion.button
            onClick={() => setIsTaskStatusOpen(true)}
            className="flex items-center space-x-1 text-slate-500 hover:text-slate-700 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <MoreHorizontal className="w-4 h-4" />
          </motion.button>
        </div>
      </div>

      {/* Description */}
      {task.comment && (
        <div className="mb-4 p-3 bg-slate-50 rounded-lg">
          <p className="text-sm text-slate-700">{task.comment}</p>
        </div>
      )}

      {/* Informations détaillées */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        {/* Assignée à */}
        {task.taskManagers && task.taskManagers.length > 0 && (
          <div className="flex items-start space-x-2">
            <Users className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Assignée à</p>
              {task.taskManagers.map((manager, index) => (
                <p key={index} className="text-sm text-slate-700">
                  {manager.firstname} {manager.lastname}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* Candidats */}
        {task.candidates && task.candidates.length > 0 && (
          <div className="flex items-start space-x-2">
            <User className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Candidats</p>
              <div className="space-y-1">
                {task.candidates.map((candidate, index) => (
                  <div key={index} className="text-sm text-slate-700">
                    <span>{candidate.firstname} {candidate.lastname}</span>
                    {candidate.phone && (
                      <span className="text-xs text-blue-600 ml-2 bg-blue-50 px-2 py-0.5 rounded">
                        {candidate.phone}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Type */}
        <div className="flex items-start space-x-2">
          <Activity className="w-4 h-4 text-slate-500 mt-0.5" />
          <div>
            <p className="text-xs font-medium text-slate-500 mb-1">Type</p>
            <p className="text-sm text-slate-700">{task.type}</p>
          </div>
        </div>

        {/* Assignateur */}
        {task.taskCreator && (
          <div className="flex items-start space-x-2">
            <User className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Créée par</p>
              <p className="text-sm text-slate-700">
                {task.taskCreator.firstname} {task.taskCreator.lastname}
              </p>
            </div>
          </div>
        )}

        {/* Clients */}
        {task.clients && task.clients.length > 0 && (
          <div className="flex items-start space-x-2">
            <Users className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Clients</p>
              <div className="space-y-1">
                {task.clients.map((client, index) => (
                  <div key={index} className="text-sm text-slate-700">
                    <span>{client.companyName}</span>
                    {client.contactPhone && (
                      <span className="text-xs text-blue-600 ml-2 bg-blue-50 px-2 py-0.5 rounded">
                        {client.contactPhone}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Date et heure */}
        {task.hour && (
          <div className="flex items-start space-x-2">
            <Clock className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Planifiée</p>
              <p className="text-sm text-slate-700">{task.hour}</p>
            </div>
          </div>
        )}
      </div>

      {/* Actions menées */}
      {(task.status === "Effectuée" && task.doneReason) && (
        <div className="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
          <div className="flex items-start space-x-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-600 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-emerald-700 mb-1">Action menée</p>
              <p className="text-sm text-emerald-800">{task.doneReason}</p>
            </div>
          </div>
        </div>
      )}

      {(task.status === "annulée" && task.cancelReason) && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-start space-x-2">
            <AlertCircle className="w-4 h-4 text-red-600 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-red-700 mb-1">Raison d'annulation</p>
              <p className="text-sm text-red-800">{task.cancelReason}</p>
            </div>
          </div>
        </div>
      )}

      {/* Actions */}

      {/* Actions */}
      <div className="flex items-center justify-between pt-4 border-t border-slate-200">
        <div className="flex items-center space-x-2">
          <motion.button
            onClick={() => setIsTaskStatusOpen(true)}
            className="flex items-center space-x-1 px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Activity className="w-3 h-3" />
            <span>Changer statut</span>
          </motion.button>
        </div>

        <div className="flex items-center space-x-2">
          <motion.button
            onClick={onView}
            className="p-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Voir les détails"
          >
            <Eye className="w-4 h-4" />
          </motion.button>

          <motion.button
            onClick={onEdit}
            className="p-2 text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Modifier"
          >
            <Edit3 className="w-4 h-4" />
          </motion.button>

          <motion.button
            onClick={onDelete}
            className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4" />
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

